import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Button, Stack } from '@mui/material';

import { getAdjacentPricingToolTabs } from './constants';
import type { PricingToolTab } from './types';

interface Props {
  activeTab: PricingToolTab;
  onTabChange: (tab: PricingToolTab) => void;
}

export default function PricingToolTabNavigation({ activeTab, onTabChange }: Props) {
  const { previous, next } = getAdjacentPricingToolTabs(activeTab);

  return (
    <Stack direction="row" sx={{ '@media print': { display: 'none' } }}>
      {previous && (
        <Button onClick={() => onTabChange(previous.value)} startIcon={<ArrowBackIcon />} variant="outlined">
          Back: {previous.label}
        </Button>
      )}
      {next && (
        <Button
          endIcon={<ArrowForwardIcon />}
          onClick={() => onTabChange(next.value)}
          sx={{ ml: 'auto' }}
          variant="contained"
        >
          Next: {next.label}
        </Button>
      )}
    </Stack>
  );
}
